import type { LogContext, LoggerBackend } from '../types';

type NewRelicAgent = {
    noticeError(error: Error, customAttributes?: Record<string, unknown>): void;
    addPageAction(name: string, attributes?: Record<string, unknown>): void;
};

function getNewRelicAgent(): NewRelicAgent | null {
    if (typeof window !== 'undefined' && window.newrelic) {
        return window.newrelic as NewRelicAgent;
    }
    return null;
}

export function createNewRelicLoggerBackend(): LoggerBackend {
    return {
        error(message: string, context?: LogContext, error?: Error): void {
            const agent = getNewRelicAgent();
            if (!agent) return;

            if (error) {
                agent.noticeError(error, { ...context, logMessage: message });
            } else {
                agent.addPageAction('error', { ...context, message });
            }
        },
        warn(message: string, context?: LogContext): void {
            const agent = getNewRelicAgent();
            if (!agent) return;

            agent.addPageAction('warn', {
                ...context,
                message,
            });
        },
        info(message: string, context?: LogContext): void {
            const agent = getNewRelicAgent();
            if (!agent) return;

            agent.addPageAction('info', {
                ...context,
                message,
            });
        },
        debug(): void {
            // No-op: New Relic does not support debug-level logging
        },
    };
}
